"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripOfferLeadingPreamble = stripOfferLeadingPreamble;
exports.prepareOfferShareText = prepareOfferShareText;
const offer_letter_amount_1 = require("./offer-letter-amount");
const PREAMBLE_LINE_RE = /^(?:Προσφορά|Πελάτης|Ποσό|Συνολικό ποσό|Ημερομηνία)\s*:/i;
/** Αφαιρεί γραμμές-«header» πριν την επίσημη προσφορά (ημερομηνία / Προς / κ.λπ.). */
function stripOfferLeadingPreamble(text) {
    const lines = text.split(/\r?\n/);
    let start = 0;
    for (let i = 0; i < lines.length; i++) {
        const t = lines[i].trim();
        if (!t)
            continue;
        if (PREAMBLE_LINE_RE.test(t))
            continue;
        if (/^Προς\s*:/i.test(t)) {
            start = i;
            break;
        }
        if (/^\d{1,2}\/\d{1,2}\/\d{4}\s*$/.test(t)) {
            start = i;
            break;
        }
        if (/^Θέμα\s*:/i.test(t)) {
            start = i;
            break;
        }
        if (/^Αγαπητέ\s/i.test(t)) {
            start = i;
            break;
        }
    }
    return lines.slice(start).join('\n').trim();
}
/** Κείμενο έτοιμο για WhatsApp / Viber / email — χωρίς header, με ποσό πριν το κλείσιμο. */
function prepareOfferShareText(text, amount) {
    const body = stripOfferLeadingPreamble(text.trim());
    return (0, offer_letter_amount_1.ensureOfferAmountLine)(body, amount);
}
